// «⋯» — ОДИН ГЛИФ ТРЁХ ТОЧЕК НА ВЕСЬ ВЕБ (ТЗ «Причины» П1б, владелец 05.10.2026: «три точки
// слишком мелкие»). Образец — SF Symbol `ellipsis` 13 pt semibold у кнопок «⋯» приложения
// (ScripteraViewController.swift ~5492, BotWindowScreen.swift `GlassCircleButton(symbol:
// "ellipsis")`); замер кадра iOS B13-chain-window (3×): рисунок 15 pt шириной, точка 3,
// шаг 6. Поле 20 — рисунок по центру (точки 4/10/16, радиус 1.5).
// Размер глифа НЕ берётся от кружка (`--ctl-ico`/`--ctl-ico-sm` масштабировали прежние копии
// до 17 — точки сжимались до 2.6 с шагом 5): класс `.k-dots` держит 20 в любом кружке (kit.css).
// INVARIANT(scriptera): своих «⋯» на страницах не рисовать — только KDots. Причина: у каждой
// копии был свой радиус и масштаб, точки разъезжались с iOS. Канон: ~/projects/WEB-CAUSES-TZ.md П1б.
export function KDots() {
  return (
    <svg className="k-dots" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
      <circle cx="4" cy="10" r="1.5" fill="currentColor" />
      <circle cx="10" cy="10" r="1.5" fill="currentColor" />
      <circle cx="16" cy="10" r="1.5" fill="currentColor" />
    </svg>
  );
}
